export default __webpack_public_path__ + "static/az-gc-e22b57cce4199a9a02b298f08825254d.png";